<div class="full-screen-container">
  <section class="registration">

    <form
      [formGroup]="registerForm"
      (ngSubmit)="onSubmit()"
      class="registration_form space-y-2"
      *ngIf="!submitted; else showResult"
    >
    <header><h2>Register User</h2></header>
      <div>
        <label for="firstName" class="block text-sm font-medium text-gray-800 mb-2">
          First Name
        </label>
        <div class="relative">
          <input
            id="firstName"
            type="text"
            formControlName="firstName"
            placeholder="Enter your First name"
            class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
            [class.border-red-300]="isFieldInvalid('firstName')"
            [class.border-gray-300]="!isFieldInvalid('firstName')"
            [class.focus:border-red-500]="isFieldInvalid('firstName')"
            [class.focus:ring-red-500]="isFieldInvalid('firstName')"
          >
          @if (isFieldInvalid('firstName')) {
            <div class="mt-2 text-sm text-red-600 flex items-center">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
              </svg>
              @if (registerForm.get('firstName').errors?.['required']) {
                First name is required.
              }
            </div>
          }
        </div>
      </div>
      <div>
        <label for="surname" class="block text-sm font-medium text-gray-800 mb-2">
          Surname
        </label>
        <div class="relative">
          <input
            id="surname"
            type="text"
            formControlName="surname"
            placeholder="Enter your Surname"
            class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
            [class.border-red-300]="isFieldInvalid('surname')"
            [class.border-gray-300]="!isFieldInvalid('surname')"
            [class.focus:border-red-500]="isFieldInvalid('surname')"
            [class.focus:ring-red-500]="isFieldInvalid('surname')"
          >
          @if (isFieldInvalid('surname')) {
            <div class="mt-2 text-sm text-red-600 flex items-center">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
              </svg>
              @if (registerForm.get('surname').errors?.['required']) {
                Surname is required.
              }
            </div>
          }
        </div>
      </div>
      <div>
        <label for="email" class="block text-sm font-medium text-gray-800 mb-2">
          Email Address
        </label>
        <div class="relative">
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Enter your email"
            class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
            [class.border-red-300]="isFieldInvalid('email')"
            [class.border-gray-300]="!isFieldInvalid('email')"
            [class.focus:border-red-500]="isFieldInvalid('email')"
            [class.focus:ring-red-500]="isFieldInvalid('email')"
          >
          @if (isFieldInvalid('email')) {
            <div class="mt-2 text-sm text-red-600 flex items-center">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
              </svg>
              @if (registerForm.get('email').errors?.['required']) {
                Email is required.
              } @else if (registerForm.get('email').errors?.['email']) {
                Please enter a valid email address.
              } @else if (registerForm.get('email').errors?.['emailExists']) {
                Email already exists.
              }
            </div>
          }
        </div>
      </div>
      <fieldset formGroupName="passwordData" class="grid">
        <div>
          <label for="password" class="block text-sm font-medium text-gray-800 mb-2">
            Password
          </label>
          <div class="relative">
            <input
              id="password"
              type="password"
              formControlName="password"
              class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
              [class.border-red-300]="isFieldInvalid('passwordData.password')"
              [class.border-gray-300]="!isFieldInvalid('passwordData.password')"
              [class.focus:border-red-500]="isFieldInvalid('passwordData.password')"
              [class.focus:ring-red-500]="isFieldInvalid('passwordData.password')"
            >
            @if (isFieldInvalid('passwordData.password') && (registerForm.get('passwordData.password').dirty || registerForm.get('passwordData.password').touched)) {
              <div class="mt-2 text-sm text-red-600 flex items-center">
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                @if (registerForm.get('passwordData.password').errors?.['required']) {
                  Password is required.
                } @else if (!registerForm.get('passwordData.password').errors?.['required']) {
                  <span>Password must contain:
                    <ul>
                      @if (registerForm.get('passwordData.password').errors['noUpper']) {
                        <li>One or more uppercase characters.</li>
                      }
                      @if (registerForm.get('passwordData.password').errors['noSpecial']) {
                        <li>One or more special characters !$&.</li>
                      }
                      @if (registerForm.get('passwordData.password').errors['minlength']) {
                        <li>8 or more characters.</li>
                      }
                    </ul>
                  </span>
                }
              </div>
            }
          </div>
        </div>
        <div>
          <label for="rptPassword" class="block text-sm font-medium text-gray-800 mb-2 mt-2">
            Repeat password
          </label>
          <div class="relative">
            <input
              id="rptPassword"
              type="password"
              formControlName="rptPassword"
              class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
              [class.border-red-300]="isFieldInvalid('passwordData.rptPassword')"
              [class.border-gray-300]="!isFieldInvalid('passwordData.rptPassword')"
              [class.focus:border-red-500]="isFieldInvalid('passwordData.rptPassword')"
              [class.focus:ring-red-500]="isFieldInvalid('passwordData.rptPassword')"
            >
            @if (!registerForm.get('passwordData').valid && registerForm.get('passwordData.password').touched  && registerForm.get('passwordData.rptPassword').touched) {
              <div class="mt-2 text-sm text-red-600 flex items-center">
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                  Your passwords don't match
              </div>
            }
          </div>
        </div>
      </fieldset>
      <button [disabled]="!registerForm.valid" type="submit" class="button button--brand">
        Register
      </button>
    </form>

    <ng-template #showResult>
      @if (!error) {
        <div class="success">
          <i class="fa fa-5x fa-check-circle"></i>
          <p>An email has been sent with a link to activate your account!</p>
          <p>Please check your spam/junk folders, If you are unable to find the email, please contact PFT Admin at admin&#64;pft.tas.gov.au</p>
        </div>
      } @else {
        <div class="error">
          <i class="fa fa-5x fa-times"></i>
          <p>{{errorMessage}}</p>
        </div>
      }
    </ng-template>

</section>

</div>
